import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'

import ProductHot from '@/components/ProductHot'
import Banner from '@/components/Banner'
import Contact from '@/components/Contact'

import { getGoodsList } from '@/api/server/goods'
import { getBrandList } from '@/api/server/brand';

export default {
  name: 'IndexPage',
  mixins: [commonMixin],
  data () {
    return {
      list: [],
      pagesize: 10,
      page: null,
      total: 0,
      hots: [],
      brandList: [],
      brandId: null,
      activeName: 'time',
      price: 0,
      order: null,
      key: null,
      cid: null,
      banner: null,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    'product-hot': ProductHot,
    Banner,
    Contact
  },
  computed: {
    priceUpStatus () {
      if (this.activeName === 'price' && this.order === 'desc') {
        return true
      } else {
        return false
      }
    },
    priceDownStatus () {
      if (this.activeName === 'price' && this.order === 'asc') {
        return true
      } else {
        return false
      }
    }  
  },
  methods: {
    onSelect (item) {
      this.brandId = item.id
      let query = {
        cid: this.cid,
        brandId: this.brandId
      }
      this.$router.push({name: 'home', query: query})
      // this.brandId = item.id
      // this.page = 1
      // this._getList()
    },
    onAll () {
      this.brandId = 0
      this.page = 1
      this._getList()
    },
    onActive (value) {
      this.activeName = value
      if (value === 'price') {
        if (this.order && this.order === 'desc') {
          this.order = 'asc'
        } else {
          this.order = 'desc'
        }
      }
      let query = {
        cid: this.cid,
        brandId: this.brandId,
        page: 1,
        order_field: this.activeName,
        order: this.order
      }
      this.$router.push({name: 'home', query: query})
    },
    onDetail (id) {
        this.$router.push({name: 'detail', query:{ id: id}});
    },
    currentPageChange (page) {
      let query = {
        cid: this.cid,
        brandId: this.brandId,
        page: page,
        order_field: this.activeName,
        order: this.order
      }
      this.$router.push({name: 'home', query: query})
        // this.page = currentPage
        // this._getList()
    },
    _getBrandList () {
      let query = {
        cid: this.cid
      }
      getBrandList(query).then( (res) => {
        if (res.code === 200) {
          this.brandList = res.data
        }
      })
    },
    _getList () {
      let query = {
          page: this.page,
          pagesize: this.pagesize,
          brand: this.brandId,
          cid: this.cid,
          order_field: this.activeName,
          order: this.order,
          keyword: this.key,
          cid: this.cid
      }
      getGoodsList(query).then((data) => {
        if (data.code === 200 && data.data && data.data.data) {
            let rdata = data.data
            this.list = rdata.data
            this.total = rdata.total
        } else {
            this.warning(data.message)
        }
      }).catch((e) => {
        console.log('err', e)
      })
    },
    reset () {
      this.list = [],
      // this.page = 1
      this.total = 0
      this.brandList = []
      if (!this.activeName) {
        this.activeName = 'time'
      }
      this.price = 0

      this._getList()
      if (this.cid) {
        this._getBrandList()
      }
    },
    handleRoute (route) {
      if (route.name === 'home') {
        this.brandId = this.$route.query.brandId ? parseInt(this.$route.query.brandId) : 0
        this.cid = this.$route.query.cid
        this.key = this.$route.query.key
        this.activeName = this.$route.query.order_field
        this.order = this.$route.query.order
        this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}